module.exports = new __parcel__URL__("BrickFlicks.0e66b069.webp").toString();